import { buildOttHeaders, ottHeaderConstants } from '@sky-uk-ott/client-lib-js-ott-common';
var HEARTBEAT_CONTENT_TYPE = 'application/vnd.heartbeat.v1+json';
export default function heartbeatRequest(userToken, config, _a, logger) {
    var streamPosition = _a.streamPosition, endpoint = _a.url;
    var timeouts = config.timeouts;
    var headers = buildOttHeaders(config.headers);
    headers["Accept" /* StandardHttpHeaderConstants.ACCEPT */] = HEARTBEAT_CONTENT_TYPE;
    headers["Content-Type" /* StandardHttpHeaderConstants.CONTENT_TYPE */] = HEARTBEAT_CONTENT_TYPE;
    headers[ottHeaderConstants.USER_TOKEN] = userToken;
    var requestParams = {
        method: "PUT" /* HTTPMethods.PUT */,
        headers: headers,
        timeouts: timeouts,
        body: JSON.stringify({ streamPosition: streamPosition }),
        logger: logger,
    };
    return [endpoint, requestParams];
}
//# sourceMappingURL=heartbeat-request.js.map